<template>
  <header>
    <picture>
      <source srcset="/images/logo.avif" type="image/avif">
      <img src="/images/logo.png" alt="Bando Tesi di laurea Ingenio al femminile" class="logo" width="490" height="161">
    </picture>
  </header>
  <VideoMessage />
  <footer>
    Powered by <a href="https://www.cving.com/?utm_source=cvweb&utm_medium=landing&utm_campaign=cvweb" target="_blank"><img src="/images/cving.png" alt="CVing" width="100" height="38"></a>
  </footer>
</template>

<script>
import VideoMessage from './components/VideoMessage.vue'

export default {
  name: 'App',
  components: {
    VideoMessage
  }
}
</script>

<style lang="scss">
  @import "normalize.css";

  :root {
    --stress-color: #ce1733;
  }

  html {
    scroll-behavior: smooth;
    font-size: 14px;
  }

  body {
    font-family: Open Sans, Arial, Helvetica, sans-serif;
  }

  .logo {
    margin: 20px auto;
    max-width: 90%;
    height: auto;
    display: block;
  }

  footer {
    margin: 30px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      margin-left: 10px;
    }
  }
  
</style>
